export const getImageUrl = (relativePath: any) => `${process.env.PUBLIC_URL}/${relativePath}`
